import React from "react";
import { OutlinedInput, InputAdornment, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear"; // Import ClearIcon

const ReusableSearch = ({
	searchQuery,
	handleSearchQueryChange,
	defaultSearchTypePlaceholder,
	searchIconPosition,
	handleSearch,
	handleClear, 
	clearIconPosition, 
}) => {
	const theme = useTheme();

	// Determine the adornments based on the provided positions
	const startAdornment = (
		<>
			{clearIconPosition === "start" && (
				<InputAdornment position="start">
					<IconButton onClick={handleClear}>
						<ClearIcon sx={{ color: theme.palette.text.primary }} />
					</IconButton>
				</InputAdornment>
			)}
			{searchIconPosition === "start" && (
				<InputAdornment position="start">
					<IconButton onClick={handleSearch}>
						<SearchIcon sx={{ color: theme.palette.text.primary }} />
					</IconButton>
				</InputAdornment>
			)}
		</>
	);

	const endAdornment = (
		<>
			{searchIconPosition === "end" && (
				<InputAdornment position="end">
					<IconButton onClick={handleSearch}>
						<SearchIcon sx={{ color: theme.palette.text.primary }} />
					</IconButton>
				</InputAdornment>
			)}
			{clearIconPosition === "end" && (
				<InputAdornment position="end">
					<IconButton onClick={handleClear}>
						<ClearIcon sx={{ color: theme.palette.text.primary }} />
					</IconButton>
				</InputAdornment>
			)}
		</>
	);

	return (
		<OutlinedInput
			placeholder={defaultSearchTypePlaceholder}
			type="text"
			value={searchQuery}
			onChange={handleSearchQueryChange}
			variant="outlined"
			sx={{
				fontFamily: "Poppins, sans-serif",
				padding: "10px",
				width: "500px",
				height: "40px",
				borderRadius: "4px",
				fontSize: '15px',
				color: theme.palette.text.primary,
				"& fieldset": {
					border: theme.palette.border.main,
				},
				"&:hover .MuiOutlinedInput-notchedOutline": {
					borderColor: theme.palette.border.main,
				},
				"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
					borderColor: theme.palette.FocusStyle.main,
				},
			}}
			startAdornment={startAdornment}
			endAdornment={endAdornment}
		/>
	);
};

export default ReusableSearch;
